<template>
  <div>
<resource object-name="Work_Resource_Service"></resource>
  </div>
</template>

<script>
import resource from "../sale_resource/resource.vue"

export default {
  components: {resource},
  created() {
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less">
</style>

